'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _contactUsModal = require('./contact-us-modal');

var _contactUsModal2 = _interopRequireDefault(_contactUsModal);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ContactUsButton = _react2['default'].createClass({
    displayName: 'ContactUsButton',

    propTypes: {
        'timePeriod': _react2['default'].PropTypes.string,
        'pricingSource': _react2['default'].PropTypes.string,
        'buttonText': _react2['default'].PropTypes.string,
        'modalHeaderText': _react2['default'].PropTypes.string,
        'onSuccess': _react2['default'].PropTypes.func
    },
    componentDidMount: function componentDidMount() {

        if (window.location.search.indexOf('showContactUs=1') > -1) {
            this.handleClick();
        }
    },
    getInitialState: function getInitialState() {
        return {
            'timePeriod': 'Y'
        };
    },
    handleClick: function handleClick(e) {
        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('contact_us_modal');
        _reactDom2['default'].render(_react2['default'].createElement(_contactUsModal2['default'], {
            timePeriod: this.state.timePeriod,
            pricingSource: this.props.pricingSource,
            headerText: this.props.modalHeaderText,
            onSuccess: this.props.onSuccess }), attachPoint);

        // Pass the event to a click handler if it was provided.
        if (this.props.onClick) {
            this.props.onClick(e);
        }
    },
    render: function render() {
        var text = this.props.buttonText !== undefined ? this.props.buttonText : 'Contact Us';
        return _react2['default'].createElement(_button2['default'], { ref: 'contactUsButton', buttonId: 'contactUsButton', buttonText: text, buttonHoverColor: 'cerulean', onClick: this.handleClick });
    }
});

module.exports = ContactUsButton;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/contact-us-button.jsx
 ** module id = 1069
 ** module chunks = 0
 **/